import { jsx as _jsx } from "react/jsx-runtime";
import { PolygonF } from '@react-google-maps/api';
export const BROADCAST_AREA_POLYGON_OPTIONS = {
    fillColor: '#D6001C',
    strokeColor: '#D6001C',
    strokeWeight: 1,
};
export const BroadcastAreaPolygon = ({ paths }) => (_jsx(PolygonF, { paths: paths, options: BROADCAST_AREA_POLYGON_OPTIONS }));
